import type { FieldErrors } from "react-hook-form"
import { useFormState } from "react-hook-form"

export default (prefix: string) => {
  const { errors } = useFormState()

  const value = prefix
    .split(".")
    .reduce<
      FieldErrors | undefined
    >((obj, key) => obj?.[key] as FieldErrors | undefined, errors)

  return !!value && !!Object.keys(value).length
}
